export default function HomeProcess() {
  return (
    <>
    <section className="home-process">
        <div className="container">
            <div className="row">

                <div className='col-lg-12'>
                    <div className='vector-heading'>
                        <img src="./assets/home/shape-vector.png" alt="vector"/>
                        <h4 className='heading'>design & <br/>execution process</h4>
                    </div>
                </div>

                <div className='col-lg-12'>
                    <div className='process-row process-top'>
                        <div className='process-box'>
                            <img src="/assets/home/process-icon-1.png" alt="vector"/>
                            <span>Initial Briefing</span>
                            {/* <p>Interia starts with detailed consultations to comprehend the client's vision, interests, and lifestyle.</p> */}
                        </div>

                        <div className='process-box'>
                            <img src="/assets/home/process-icon-2.png" alt="vector"/>
                            <span>Space Analysis</span>
                            {/* <p>Interia conducts an expansive space evaluation to select the right lighting, layout, and decor.</p> */}
                        </div>

                        <div className='process-box'>
                            <img src="/assets/home/process-icon-3.png" alt="vector"/>
                            <span>Concept Phase</span>
                            {/* <p>Our interior designers in Gurgaon develop tailored concepts blending creativity with client preferences.</p> */}
                        </div>
                        
                        <div className='process-box'>
                            <img src="/assets/home/process-icon-4.png" alt="vector"/>
                            <span>Design Planning</span>
                            {/* <p>Technical drawings and blueprints are developed to chalk out the ideal design layout leading to success.</p> */}
                        </div>
                    </div>

                    <div className='process-divider'>
                        <img src="/assets/home/element.png" alt="vector"/>
                        <img src="/assets/home/element.png" alt="vector"/>
                    </div>

                    <div className='process-row process-bottom'>
                    <div className='process-box'>
                            <img src="/assets/home/process-icon-5.png" alt="vector"/>
                            <span>Material Selection</span>
                            {/* <p>Premium materials are carefully selected for their quality & longevity, meeting functionality & aesthetics.</p> */}
                        </div>

                        <div className='process-box'>
                            <img src="/assets/home/process-icon-6.png" alt="vector"/>
                            <span>Custom Furniture</span>
                            {/* <p>Custom furniture is assembled in-house, merging design and utility, and established on client specifications.</p> */}
                        </div>

                        <div className='process-box'>
                            <img src="/assets/home/process-icon-7.png" alt="vector"/>
                            <span>Skilled Execution</span>
                            {/* <p>Our best interior designers in Gurgaon blend excellent planning ensuring careful alignment with the idea.</p> */}
                        </div>

                        <div className='process-box'>
                            <img src="/assets/home/process-icon-8.png" alt="vector"/>
                            <span>Final Stage</span>
                            {/* <p>Interia ensures every design element meets their quality expectations leading to utmost client satisfaction.</p> */}
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </section>
    </>
  )
}
